export default "__VITE_ASSET__ct82LdlQ__"